/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import styles from './styles.scss';

export class Close extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 20 20"
          xmlSpace="preserve"
        >
        <g id="fDroMD.tif">
          <g>
            <path className={styles.st0}
              d="M10.1,14.1c-0.8,0.8-1.6,1.6-2.3,2.3c-0.7,0.7-1.4,1.4-2.1,2.1c-0.6,0.6-1.5,0.7-2.2,0c-0.7-0.7-1.3-1.3-2-2
              c-0.6-0.6-0.6-1.5,0-2.1c1.4-1.4,2.8-2.8,4.2-4.2c0.1-0.1,0.1-0.1,0.2-0.2C5.9,10,5.8,9.9,5.7,9.9C4.3,8.5,2.9,7.1,1.6,5.7
              C0.9,5,0.9,4.2,1.6,3.5c0.6-0.6,1.3-1.3,1.9-1.9c0.7-0.7,1.5-0.7,2.2,0C7.1,3,8.4,4.4,9.8,5.8C9.9,5.8,9.9,5.9,10,6
              c0.1-0.1,0.2-0.2,0.2-0.2C11.6,4.4,13,3,14.4,1.6c0.7-0.7,1.6-0.7,2.3,0c0.6,0.6,1.2,1.2,1.9,1.9c0.7,0.7,0.7,1.5,0,2.2
              c-1.4,1.4-2.8,2.8-4.1,4.1c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2c1.4,1.4,2.8,2.8,4.1,4.1c0.5,0.5,0.6,1,0.4,1.6
              c-0.1,0.2-0.2,0.4-0.4,0.6c-0.6,0.7-1.3,1.3-2,2c-0.6,0.6-1.5,0.6-2.1,0c-1.4-1.4-2.8-2.8-4.1-4.1C10.2,14.4,10.2,14.3,10.1,14.1z
              "
            />
          </g>
        </g>
        </svg>
      </div>
    );
  }
}

Close.propTypes = {
  className: PropTypes.string,
};

export default Close;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/close/index.jsx